export var FarmManagementCategory;
(function (FarmManagementCategory) {
    FarmManagementCategory[FarmManagementCategory["Products"] = 1] = "Products";
    FarmManagementCategory[FarmManagementCategory["FarmSupplies"] = 7] = "FarmSupplies";
    FarmManagementCategory[FarmManagementCategory["Materials"] = 14] = "Materials";
    FarmManagementCategory[FarmManagementCategory["IslandProducts"] = 26] = "IslandProducts";
    FarmManagementCategory[FarmManagementCategory["NordlandProducts"] = 28] = "NordlandProducts";
})(FarmManagementCategory || (FarmManagementCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/FarmManagementCategory.ts
// module id = 2642
// module chunks = 3